import React, { useState, useEffect } from 'react';
import './AddCategoryModal.css';

const AddCategoryModal = ({ isOpen, onClose, onAddCategory, initialData = null, title = "Aggiungi Categoria" }) => {
  const [formData, setFormData] = useState({
    nome: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Aggiorna il form quando cambia initialData
  useEffect(() => {
    if (initialData) {
      setFormData({
        nome: initialData.nome || ''
      });
    } else {
      setFormData({ nome: '' });
    }
  }, [initialData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await onAddCategory(formData);
      // Reset form
      setFormData({ nome: '' });
      onClose();
    } catch (err) {
      setError(err.message || 'Errore durante l\'aggiunta della categoria');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ nome: '' });
    setError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* X nell'angolo in alto a destra */}
        <button className="modal-close-button" onClick={handleClose}>
          ×
        </button>
        
        <div className="modal-header">
          <h2>{title}</h2>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="nome">Nome Categoria</label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
              placeholder="Inserisci il nome della categoria"
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <div className="modal-actions">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={handleClose}
              disabled={loading}
            >
              Annulla
            </button>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (initialData ? 'Modifica in corso...' : 'Aggiunta in corso...') : (initialData ? 'Modifica' : 'Aggiungi')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategoryModal;
